module.exports = __webpack_public_path__ + "static/media/RingRotate.2530d38f.png";